import { MwNumberDelta } from '@meltwater/mw-visualizations';
import RenderApi from '../render-api';
import { getCurrentStateFromChanges } from '../get-current-state-from-changes';

export default class NgMwNumberDelta {
    static get componentName() {
        return 'mwNumberDelta';
    }
    static get config() {
        return {
            template: `
                <div ng-show="!$ctrl.error" style="height:100%;"></div>
                <div ng-if="$ctrl.error">An error occurred while trying to render this chart. Please try again later.</div>
            `,
            controller: NgMwNumberDelta,
            bindings: {
                data: '<',
                options: '<',
                getApi: '&?',
                onError: '&?'
            }
        };
    }

    constructor($element, $q, $log) {
        'ngInject';

        this.$q = $q;
        this.$log = $log;

        const renderTarget = $element[0].children[0];
        this.__mwNumberDelta = new MwNumberDelta(renderTarget);
    }

    $onInit() {
        if(this.getApi && typeof this.getApi !== 'function') {
            throw new TypeError(`If provided, getApi must be a function. Provided value: ${JSON.stringify(this.getApi)}`);
        }

        if(this.getApi) {
            const Api = new RenderApi({
                redraw: this.__mwNumberDelta.render.bind(this.__mwNumberDelta)
            });
            this.getApi({API: Api});
        }
    }

    async $onChanges(changes) {
        this.error = false;
        try {
            const resolvedChanges = getCurrentStateFromChanges(changes);
            const data = await resolvedChanges.data;
            const options = await resolvedChanges.options;

            this.__mwNumberDelta.setData(data);
            this.__mwNumberDelta.setOptions(options);

            this.__mwNumberDelta.render();
        } catch(error) {
            this.error = true;

            if (this.onError) {
                if (typeof this.onError !== 'function') {
                    throw new TypeError(`If provided, onError must be a function. Provided value: ${JSON.stringify(this.onError)}`);
                }

                this.onError({ error });
            } else {
                this.$log.error(error);
            }
        }

        return this.$q.resolve().then(function forceDigest() {});
    }
}
